module.exports = __webpack_public_path__ + "static/media/logo_bb_italia.f045389d.svg";